import React, { Fragment, memo } from 'react';
import { Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ConfirmPassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Form.Item
        label={t('password')}
        name='password'
        rules={[{ required: true, message: t('please_input_password') }]}
      >
        <Input.Password
          placeholder={t('please_enter')}
          prefix={<LockOutlined />}
          autoComplete='new-password'
        />
      </Form.Item>
      <Form.Item
        label={t('ensure_password')}
        name='rePassword'
        rules={[
          { required: true, message: t('please_ensure_password') },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t('passwords_inconsistent')));
            },
          }),
        ]}
      >
        <Input.Password
          placeholder={t('please_enter')}
          prefix={<LockOutlined />}
          autoComplete='new-password'
        />
      </Form.Item>
    </Fragment>
  );
};

export default memo(ConfirmPassword);
